import React, { useState, useEffect } from 'react';
const FadeInOut = ({ visiable = false, children, unmountOnHide = false }) => {
    const [show, setShow] = useState(visiable);
    useEffect(() => {
        if (visiable) {
            setShow(true);
        }
        else {
            const timer = setTimeout(() => {
                if (unmountOnHide) {
                    setShow(false);
                }
                else {
                    setShow(true);
                }
            }, 300);
            return () => clearTimeout(timer);
        }
    }, [visiable, unmountOnHide]);
    return (React.createElement("div", { style: {
            opacity: show ? 1 : 0,
            transition: 'opacity 0.3s ease-in',
        } }, !unmountOnHide || show ? children : null));
};
export default FadeInOut;
